if (!customElements.get('product-custom-request')) {
  customElements.define(
    'product-custom-request',
    class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.dialog = this.querySelector('dialog');
        this.trigger = document.getElementById(this.dataset.triggerId);

        this.trigger?.addEventListener('click', () => {
          if (!this.dialog.open) this.dialog.showModal();
        });

        this.querySelectorAll('[data-custom-request-close]').forEach((button) => {
          button.addEventListener('click', () => this.dialog.close());
        });

        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          const inside =
            event.clientX >= rect.left &&
            event.clientX <= rect.right &&
            event.clientY >= rect.top &&
            event.clientY <= rect.bottom;
          if (!inside) this.dialog.close();
        });

        this.dialog.addEventListener('close', () => this.trigger?.focus());

        if (this.querySelector('[data-custom-request-open-on-load]') && !this.dialog.open) {
          this.dialog.showModal();
        }
      }
    }
  );
}

